import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useFormattedVolume = (
    options: Intl.NumberFormatOptions = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    },
) => {
    const { t, i18n } = useTranslation('common');

    const numberFormatter = useMemo(() => {
        return new Intl.NumberFormat(i18n.language, options);
    }, [i18n.language, options]);

    const UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const GB_INDEX = 3;

    const formatVolume = (
        gbValue: number | string | undefined | null,
    ): string => {
        if (gbValue == null) return `0 ${t('units.GB')}`;
        const parsedValue =
            typeof gbValue === 'string' ? parseFloat(gbValue) : gbValue;

        if (isNaN(parsedValue) || parsedValue <= 0) return `0 ${t('units.GB')}`;

        const exponent = Math.floor(Math.log(parsedValue) / Math.log(1024));
        const unitIndex = Math.max(
            0,
            Math.min(GB_INDEX + exponent, UNITS.length - 1),
        );

        const displayValue = parsedValue / Math.pow(1024, unitIndex - GB_INDEX);

        return `${numberFormatter.format(displayValue)} ${t(`units.${UNITS[unitIndex]}`)}`;
    };

    return { formatVolume };
};
